import "../../InsightsLabel/./critical-icon.css";
import React from 'react';

var CriticalIcon = function CriticalIcon() {
  return /*#__PURE__*/React.createElement("svg", {
    className: "ins-c-critical-icon",
    viewbox: "0 0 10 10"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "10 10, 10 3, 5 0, 0 3, 0 10, 5 8"
  }));
};

export default CriticalIcon;